import jQuery from 'jquery';

/**
 * case insensitive jquery "contains" selector
 */
export default (function () {
  jQuery.expr[':'].icontains = function (obj, index, meta) {
    return (obj.textContent || obj.innerText || jQuery(obj).text() || '').toLowerCase().indexOf(meta[3].toLowerCase()) >= 0;
  };
}());
